<template>
	<v-container
		:style="
			'padding: 0; margin: 0;width: 100%; height:' +
			heightCard +
			'; overflow: auto;'
		"
		fill-height
		fluid
		wrap
	>
		<v-layout :style="heightOverflow" row wrap>
			<v-flex
				:style="
					'width: 100%; height:' +
					heightCard +
					'; overflow: auto; overflow-x: hidden;'
				"
			>
				<v-flex xs12 md12>
					<material-card color="secundary" text="">
						<v-flex xs12>
							<h3>
								<v-icon>mdi-corn</v-icon> <v-divider vertical />
								{{ strings[idioma].alimentos }}
							</h3>
						</v-flex>
						<v-flex xs12 class="v-chip-link" style="display: flex">
							<v-chip
								color="indigo"
								dark
								small
								@click="
									tabFuncionalidade = 0;
									route = '';
								"
							>
								<v-icon>mdi-nutrition</v-icon
								>{{ strings[idioma].tabela_resumida }}
							</v-chip>
							<v-chip color="indigo" dark small @click="tabFuncionalidade = 1">
								<v-icon>mdi-corn</v-icon>{{ strings[idioma].meus_alimentos }}
							</v-chip>
							<v-chip
								color="indigo"
								dark
								small
								@click="go('/enviar-alimento/cqbal')"
							>
              <v-icon>mdi-send</v-icon> {{  strings[idioma].enviar_cqbal }}
							</v-chip>
							<v-chip
								color="white"
								dark
								style="margin-left: auto"
								@click="dialog = true"
							>
								<v-icon large color="indigo">mdi-plus-circle</v-icon>
							</v-chip>
						</v-flex>
					</material-card>
				</v-flex>
				<v-flex v-if="tabFuncionalidade === 0">
					<TabelaResumida />
				</v-flex>
				<template v-if="tabFuncionalidade === 1">
					<v-flex
						v-if="
							getAcessoModulo({
								user: user,
								modulo: LISTAR_ALIMENTOS_USUARIO,
							}) &&
							alimentosUsuario &&
							alimentosUsuario.length > 0
						"
						:xs12="alimentosUsuario"
					>
						<material-card color="indigo lighten-5 font-weight-bold">
							<v-text-field
								:label="strings[idioma].pesquisar"
								v-model="searchAlimentos"
								flat
								hide-details
								clearable
								append-icon="mdi-magnify"
								clear-icon="mdi-close"
							/>
							<v-divider />
							<v-tabs v-model="tab">
								<v-tab
									v-show="
										getAcessoModulo({
											user: user,
											modulo: LISTAR_ALIMENTOS_USUARIO,
										}) ||
										(user.emp_user && user.emp_user.acesso === 0) ||
										user.permissao === 0
									"
									>{{ strings[idioma].cadastrado_titulo }}</v-tab
								>
								<v-tab
									v-show="
										(user.empresa_vinculada &&
											user.empresa_vinculada.length > 0 &&
											user.emp_user &&
											user.emp_user.acesso === 0) ||
										user.permissao === 0
									"
									>{{ strings[idioma].empresa }}</v-tab
								>
								<v-tab
									v-show="
										getAcessoModulo({
											user: user,
											modulo: ENVIAR_ALIMENTO_ADAPTADO,
										})
									"
									>{{ strings[idioma].adaptado }}</v-tab
								>
								<v-tab
									v-show="
										getAcessoModulo({
											user: user,
											modulo: ENVIAR_ALIMENTO_ADAPTADO,
										})
									"
									>{{ strings[idioma].suplemento_racao }}</v-tab
								>
							</v-tabs>
							<div
								v-if="categorias_alimentos && categorias_alimentos !== null"
								style="
									padding: 0;
									margin: 0;
									max-height: 200px;
									width: 100%;
									overflow: auto;
								"
							>
								<v-list
									v-for="us in alimentosFilterUsuario"
									:key="us.id"
									:style="us.EXCLUIDO === 1 ? 'opacity: 0.6;' : null"
									dense
									flat
									rounded
								>
									<v-list-tile
										flat
										@click="
											remove && !copiar
												? removeAlimento(us)
												: !copiar
												? openAlimentoUsuario(us)
												: null
										"
									>
										<v-list-tile-avatar>
											<v-icon v-text="'mdi-nutrition'" />
										</v-list-tile-avatar>
										<v-list-tile-content>
											<v-list-tile-title>
												{{
													us.empresa && us.empresa.nome
														? us.empresa.nome + " - "
														: ""
												}}{{ us.nome }} - <i>{{ us.nome_cientifico }}</i>
												&nbsp;
												<template v-if="us.cliente && us.cliente !== null">
													<b
														>({{
															us.id_cliente === null
																? strings[idioma].base_pessoal
																: us.cliente.nome
														}})</b
													>
												</template>
												<template v-else>
													<b
														>({{
															us.publico
																? strings[idioma].publico
																: us.id_empresa
																? strings[idioma].livre_acesso_empresa
																: strings[idioma].base_pessoal
														}})</b
													>
												</template>
											</v-list-tile-title>
											<v-list-tile-sub-title
												v-if="us.id_tipo && us.id_tipo !== null"
												>{{
													tipos.filter((c) => c.id === us.id_tipo)[0][
														idioma === 0
															? "nome"
															: idioma === 1
															? "nome_ingles"
															: "nome_espanhol"
													]
												}}
												<span
													v-if="
														!us.publico &&
														!us.id_empresa &&
														user.emp_user &&
														user.emp_user.acesso === 0
													"
												>
													-
													<a
														small
														@click="
															copiar = true;
															copiarAlimentoParaEmpresa(us);
														"
														>{{
															strings[idioma].transformar_alimento_empresa
														}}</a
													></span
												>
											</v-list-tile-sub-title>
										</v-list-tile-content>
										<v-list-tile-action>
											<v-btn flat color="error" small @click="remove = true">
												X
											</v-btn>
										</v-list-tile-action>
									</v-list-tile>
								</v-list>
							</div>
						</material-card>
					</v-flex>
					<v-flex v-else>
						<p>{{ strings[idioma].cqbal_info_legal }}</p>
					</v-flex>
				</template>

				<EnviarAlimentoCQBAL v-else-if="route === 'cqbal'" />
				<EnviarAlimentoPessoal v-else-if="route === 'privado'" />
				<AdaptarAlimento v-else-if="route === 'adaptar'" />
			</v-flex>
			<template>
				<div>
					<v-dialog v-model="dialog" width="400px" >
						<v-card>
							<div style="text-align: center">
								<div style="text-align: center">

                  <v-chip
                    style="margin-top: 20px;text-align: center;font-size: larger;"
                    v-if="
                      !getAcessoModulo({
                        user: user,
                        modulo: ESCONDER_BOTAO_ENVIAR_ALIMENTO_ADAPTADO,
                      })
                    "
                    :disabled="
                      !getAcessoModulo({
                        user: user,
                        modulo: ENVIAR_ALIMENTO_ADAPTADO,
                      })
                    "
                    color="indigo"
                    dark
                    @click="go('/enviar-alimento/adaptar')"
                  >
                    <span style="margin: auto;">{{ strings[idioma].adaptar_alimento }}</span>
                  </v-chip>
                </div>
                <div>

                  <v-chip
                    :disabled="
                      !getAcessoModulo({ user: user, modulo: ENVIAR_ALIMENTO })
                    "
                    color="indigo"
                    dark
                    style="font-size: larger;"
                    @click="go('/enviar-alimento/privado')"
                  >
                    {{ strings[idioma].enviar_base_pessoal }}
                  </v-chip>
                </div>
                <div>

                  <v-chip
                    v-if="
                      getAcessoModulo({
                        user: user,
                        modulo: ENVIAR_ALIMENTO_EMPRESA,
                      })
                    "
                    color="indigo"
                    dark
                    @click="enviarEmpresa()"
                    style="font-size: larger;"
                  >
                    {{ strings[idioma].enviar_para_empresa }}
                  </v-chip>
                </div>

								<v-chip
									color="red"
									dark
									@click="dialog = false"
									style="margin-top: 20px; margin-bottom: 20px;font-size: larger;"
								>
									{{ strings[idioma].fechar }}
								</v-chip>
							</div>
						</v-card>
					</v-dialog>
				</div>
			</template>
		</v-layout>
	</v-container>
</template>

<script>
import { mapState } from "vuex";
import TabelaResumida from "../views/TabelaResumida";
import Dashboard from "./alimentos/Dashboard";
import EnviarAlimentoCQBAL from "./alimentos/EnviarAlimentoCQBAL";
import EnviarAlimentoPessoal from "./alimentos/EnviarAlimentoPessoal";
import AdaptarAlimento from "./alimentos/AdaptarAlimento";
import { getAlimentosEmpresa, getAlimentos } from "../utils/utils";
import {
	ENVIAR_ALIMENTO,
	LISTAR_ALIMENTOS_USUARIO,
	ENVIAR_ALIMENTO_ADAPTADO,
	ENVIAR_ALIMENTO_EMPRESA,
	ESCONDER_BOTAO_ENVIAR_ALIMENTO_ADAPTADO,
} from "../utils/types";

export default {
	components: {
		Dashboard,
		EnviarAlimentoCQBAL,
		EnviarAlimentoPessoal,
		AdaptarAlimento,
		TabelaResumida,
	},
	data: () => ({
		tabFuncionalidade: 0,
		tab: 2,
		dialog: false,
		copiar: null,
		remove: null,
		alimentosUsuario: [],
		searchAlimentos: null,
		alimento: {
			nome: "",
			nome_sci: "",
			tipo: null,
			nutrientes: {},
			user: {},
		},
		stepComplete: [false, false],
		step: 1,
		basePessoal: false,
		tabsEnum: ["privados", "empresa", "adaptado", 'suplementos'],
		route: "",
		route2: "",
		font_size: 12,
		logo: "img/brcorte-logo.png",
		ENVIAR_ALIMENTO_ADAPTADO: ENVIAR_ALIMENTO_ADAPTADO,
		ENVIAR_ALIMENTO_EMPRESA: ENVIAR_ALIMENTO_EMPRESA,
		ENVIAR_ALIMENTO: ENVIAR_ALIMENTO,
		LISTAR_ALIMENTOS_USUARIO: LISTAR_ALIMENTOS_USUARIO,
		ESCONDER_BOTAO_ENVIAR_ALIMENTO_ADAPTADO:
			ESCONDER_BOTAO_ENVIAR_ALIMENTO_ADAPTADO,
	}),
	computed: {
		...mapState("app", [
			"strings",
			"idioma",
			"user",
			"ingredientes",
			"optionsNumber",
			"alimentos_selecionados",
			"categorias_alimentos",
			"alert",
			"dietas",
			"predicoes",
			"tabelas",
			"empresa",
			"user",
			"acesso_premium",
			"tipos",
			"alimentos_empresa",
		]),
		binding() {
			const binding = {};
			if (this.$vuetify.breakpoint.mdAndUp) binding.row = true;
			else binding.row = false;
			return binding;
		},
		filter() {
			return (item, search, textKey) =>
				item[textKey].toLowerCase().search(search.toLowerCase()) > -1;
		},
		heightCard() {
			return String(this.$vuetify.breakpoint.height - 50) + "px";
		},
		heightDialog() {
			return this.$vuetify.breakpoint.xs
				? String(this.$vuetify.breakpoint.height - 150) + "px"
				: String(this.$vuetify.breakpoint.height - 240) + "px";
		},
		heightOverflow() {
			return (
				"max-height: " +
				String(this.$vuetify.breakpoint.height - 120) +
				"px; overflow: auto; padding-bottom: 65px;"
			);
		},
		heightTree() {
			return (
				"max-height: " +
				String(this.$vuetify.breakpoint.height - 200) +
				"px; overflow: auto; min-height: 200px;"
			);
		},
		usersFilter() {
			if (this.searchUsers === null || this.searchUsers.trim() === "")
				return this.users;
			return this.users.filter((u) => {
				const reg = new RegExp(
					replaceSpecialChars(this.searchUsers.toLowerCase()),
					"i"
				);
				return (
					reg.test(u.NOME) ||
					reg.test(u.email) ||
					u.id === parseInt(this.searchUsers) ||
					"#" + u.id === this.searchUsers
				);
			});
		},
		empresasFilter() {
			if (this.searchEmpresas === null || this.searchEmpresas.trim() === "")
				return this.empresas;
			return this.empresas.filter(
				(u) =>
					new RegExp(
						replaceSpecialChars(this.searchEmpresas.toLowerCase()),
						"i"
					).test(u.nome) ||
					u.id === parseInt(this.searchEmpresas) ||
					"#" + u.id === this.searchEmpresas
			);
		},
		alimentosFilter() {
			if (this.searchAlimentos === null || this.searchAlimentos.trim() === "")
				return this.alimentos === null
					? []
					: this.alimentos.filter((a) => a.patrocinado !== 0);
			return this.alimentos === null
				? []
				: this.alimentos
						.filter((a) => a.patrocinado !== 0)
						.filter(
							(u) =>
								new RegExp(
									replaceSpecialChars(this.searchAlimentos.toLowerCase()),
									"i"
								).test(u.nome) ||
								u.id === parseInt(this.searchAlimentos) ||
								"#" + u.id === this.searchAlimentos
						);
		},
		alimentosFilterUsuario() {
			let als = this.alimentosUsuario;
			switch (this.tabsEnum[this.tab]) {
				case "privados":
					als = als.filter(
						(a) => a.id_empresa === null && a.id_alimento_pai === null && a.id_dieta === null
					);
					break;
				case "empresa":
					als = als.filter(
						(a) => a.id_empresa !== null && a.id_alimento_pai === null
					);
					break;
				case "adaptado":
					als = als.filter(
						(a) => a.id_alimento_pai !== null && a.id_empresa === null
					);
					break;
				case "suplementos":
					als = als.filter(
						(a) => a.id_empresa === null && a.id_alimento_pai === null && a.id_dieta !== null
					);
					break;
				default:
					als = als.filter(
						(a) => a.id_empresa === null && a.id_alimento_pai === null
					);
					break;
			}
			if (this.searchAlimentos === null || this.searchAlimentos.trim() === "")
				return als;
			let cliente = localStorage.getItem("cliente");
			let clienteID = null;
			if (cliente !== null) {
				cliente = JSON.parse(cliente);
				clienteID = parseInt(cliente.id);
			}
			als = als.filter(
				(p) =>
					new RegExp(
						replaceSpecialChars(this.searchAlimentos.toLowerCase()),
						"i"
					).test(
						p.id + "-" + p.nome + "-" + p.nome_ingles + "-" + p.nome_espanhol
					) &&
					p.nome !== null &&
					String(p.nome).trim() !== "" &&
					!p.EXCLUIDO
			);

			return als;
		},
	},
	watch: {
		tab(val) {
			let al = JSON.stringify(this.alimentosUsuario);
			this.alimentosUsuario = [];
			this.alimentosUsuario = JSON.parse(al);
		},
		idioma(val) {
			window.location.reload();
		},
	},
	created() {
		this.route = this.$route.path.split("/")[2];
		this.route2 = this.$route.path.split("/")[3];

		this.$store.dispatch("getTipos");
		this.escolha = this.getAcessoModulo({
			user: this.user,
			modulo: LISTAR_ALIMENTOS_USUARIO,
		});
		this.loadAlimentosDieta();
		if (!this.$store.state.app.categorias_alimentos) {
			this.loadingAlimentos = true;
			this.axios.post("alimentos/lastUpdateAt", {}).then((response) => {
				this.getClientes();
				let lastUpdate = parseInt(response.data.data[1]);
				if (lastUpdate === parseInt(localStorage.getItem("lastUpdate"))) {
					let tipos = JSON.parse(localStorage.getItem("tipos"));
					let alimentos = JSON.parse(localStorage.getItem("alimentos"));
					alimentos = alimentos.filter((a) => a.nutrientes.NDT_BRCORTE2016 !== 0 && a.id_tipo !== 8);
					this.$store.commit("setAlimentos", {
						tipos: tipos,
						alimentos: alimentos,
					});
					this.loadingAlimentos = false;
				} else {
					this.axios.post("tipos", {}).then((response) => {
						let tipos = response.data.data;
						localStorage.setItem("tipos", JSON.stringify(tipos));
						this.axios
							.post("relatorio/alimentosBrCorte", {})
							.then((response) => {
								localStorage.setItem(
									"alimentos",
									JSON.stringify(response.data.data)
								);
								this.$store.commit("setAlimentos", {
									tipos: tipos,
									alimentos: response.data.data,
								});
								this.loadingAlimentos = false;
								localStorage.setItem("lastUpdate", lastUpdate);
							})
							.catch((error) => {
								console.log(error);
							});
					});
				}
			});
		}
		let meusAlimentos = [];
		let cliente = localStorage.getItem("cliente");
		if (cliente !== null) {
			cliente = JSON.parse(cliente).id;
		}
		this.axios
			.post("alimentos/getAlimentosUsuario", { id_pessoa: this.user.id })
			.then((res) => {
				for (let al of res.data.data) {
					let alim = Object.assign({}, al);
					alim["nutrientes"] = JSON.parse(al.nutrientes);
					meusAlimentos.push(alim);
				}
				this.alimentosUsuario = meusAlimentos;
				this.$store.commit("setAlimentosUsuario", { alimentos: meusAlimentos });

				if (
					this.user.empresa_vinculada &&
					this.user.empresa_vinculada.length > 0 &&
					this.user.emp_user &&
					this.user.emp_user.acesso === 0
				) {
					this.tab = 2;
					getAlimentosEmpresa(
						this.$store.state,
						this.empresa.id,
						this.axios,
						true
					).then((r) => {
						if (meusAlimentos.length === 0) this.tab = 1;
						for (let al of this.alimentos_empresa) {
							this.alimentosUsuario.push(al);
						}
					});
				} else {
					if (meusAlimentos.length === 0) this.tab = 2;
					else this.tab = 0;
				}
			});

		if (
			this.route === "privado" ||
			this.route === "add-alimento" ||
			this.route === "adaptar" ||
			this.route === "cqbal"
		)
			this.tabFuncionalidade = 3;

		if (this.route === undefined || this.route === null) this.route = "/";
	},
	methods: {
		go(url) {
			window.location.href = url;
		},
		mudarEmpresa() {
			sessionStorage.removeItem("empresaAdm");
			this.go("/empresa");
		},
		enviarEmpresa() {
			sessionStorage.removeItem("empresaAdm");
			sessionStorage.removeItem("alimentoCarregado");
			this.go("/empresa/add-alimento");
		},
		getClientes() {
			if (!this.user.consultoria || !this.user.consultoria.id) return null;
			return this.axios
				.post("consultoria/clientes", { id: this.user.consultoria.id })
				.then((r) => {
					this.clientes = r.data.data;
					return this.clientes;
				});
		},
		resetAlimento() {
			this.alimento = {
				nome: "",
				nome_sci: "",
				tipo: null,
				nutrientes: {},
				user: {},
			};
		},
		openAlimento(al) {
			let alimento = Object.assign({}, al);
			alimento.nome_sci = alimento.nome_cientifico;
			alimento.tipo = alimento.id_tipo;
			for (let nut in alimento.nutrientes) {
				alimento.nutrientes[nut] = parseFloat(alimento.nutrientes[nut])
					.toFixed(2)
					.replace(".", this.strings[this.idioma].separador_float);
			}
			this.alimento = alimento;
			this.stepComplete[0] = true;
			this.step = 2;
			this.basePessoal = true;
			sessionStorage.setItem("alimentoCarregado", JSON.stringify(alimento));
			// window.location.href = '/empresa/add-alimento'
		},
		openAlimentoUsuario(al) {
			let alimento = Object.assign({}, al);
			alimento.nome_sci = alimento.nome_cientifico;
			alimento.tipo = alimento.id_tipo;
			if (typeof alimento.nutrientes === "string") {
				alimento.nutrientes = JSON.parse(alimento.nutrientes);
			}

			for (let nut in alimento.nutrientes) {
				if (alimento.nutrientes_raw) {
					alimento.nutrientes_raw[nut] = parseFloat(
						parseFloat(alimento.nutrientes[nut])
							.toFixed(2)
							.replace(this.strings[this.idioma].separador_float, ".")
					);
				}
				alimento.nutrientes[nut] = parseFloat(alimento.nutrientes[nut])
					.toFixed(2)
					.replace(".", this.strings[this.idioma].separador_float);
			}
			this.alimento = alimento;
			this.stepComplete[0] = true;
			this.step = 2;
			this.basePessoal = true;
			sessionStorage.setItem("alimentoCarregado", JSON.stringify(alimento));
			if (
				this.user.permissao === 0 &&
				alimento.id_empresa &&
				this.user.empresa_vinculada
			)
				sessionStorage.setItem(
					"empresaAdm",
					JSON.stringify(this.user.empresa_vinculada[0])
				);
			if (alimento.id_empresa && alimento.id_empresa !== null) {
				sessionStorage.setItem("id_empresa", alimento.id_empresa);
				window.location.href = "/empresa/add-alimento";
			} else if (alimento.id_alimento_pai && alimento.id_alimento_pai !== null)
				window.location.href = "/enviar-alimento/adaptar";
			else window.location.href = "/enviar-alimento/privado";
		},
		removeAlimento(al) {
			delete this.remove;
			if (confirm(this.strings[this.idioma].msg_remove)) {
				this.axios
					.post("alimentos/removeAlimento", { id: al.id })
					.then((res) => {
						let meusAlimentos = [];
						this.axios
							.post("alimentos/getAlimentosUsuario", {
								id_pessoa: this.user.id,
							})
							.then((res) => {
								for (let al of res.data.data) {
									let alim = Object.assign({}, al);
									alim["nutrientes"] = JSON.parse(al.nutrientes);
									meusAlimentos.push(alim);
								}
								this.alimentosUsuario = meusAlimentos;
								// this.$store.commit('setAlimentosUsuario', { alimentos: meusAlimentos })
							});
					})
					.catch(() => alert("Erro, ao remover o alimento!!!"));
			}
		},
		copiarAlimentoParaEmpresa(al) {
			let alimento = Object.assign({}, al);
			alimento.nome_sci = alimento.nome_cientifico;
			alimento.tipo = alimento.id_tipo;
			alimento.id_empresa = this.user.emp_user.id_empresa;
			alimento.empresa = this.user.empresa_vinculada;
			for (let nut in alimento.nutrientes) {
				alimento.nutrientes[nut] = parseFloat(alimento.nutrientes[nut])
					.toFixed(2)
					.replace(".", this.strings[this.idioma].separador_float);
			}
			alimento.id = null;
			delete alimento.id;
			this.alimento = alimento;
			this.stepComplete[0] = true;
			this.step = 2;
			this.basePessoal = true;
			sessionStorage.setItem("alimentoCarregado", JSON.stringify(alimento));
			window.location.href = "/empresa/add-alimento";
		},
		changeIngrediente(ingrediente, nutriente, unidade) {
			let val = this.parseString(nutriente, this.idioma);
			this.alimento.nutrientes[ingrediente] = isNaN(
				this.alimento.nutrientes[ingrediente]
			)
				? 0
				: this.alimento.nutrientes[ingrediente];

			if (unidade === "%") {
				this.alimento.nutrientes[ingrediente] =
					this.idioma === 0 || this.idioma === 2
						? (val > 100 ? 100 : val < 0 || isNaN(val) ? 0 : val)
								.toFixed(2)
								.replace(",", "")
								.replace(".", ",")
						: (val > 100 ? 100 : val < 0 ? 0 : val)
								.toFixed(2)
								.replace(".", ",");
			} else {
				this.alimento.nutrientes[ingrediente] =
					this.idioma === 0 || this.idioma === 2
						? (val < 0 || isNaN(val) ? 0 : val)
								.toFixed(2)
								.replace(",", "")
								.replace(".", ",")
						: (val < 0 || isNaN(val) ? 0 : val).toFixed(2).replace(".", ",");
			}
			return this.alimento.nutrientes[ingrediente];
		},
		parseString(valor, idioma) {
			if ((this.idioma === 0 || this.idioma === 2) && valor && valor !== "-") {
				if (valor[valor.length - 3] === ".") return parseFloat(valor);
				return parseFloat(valor.replace(/[.]/g, "").replace(/[,]/g, "."));
			} else if (valor && valor !== "-") {
				return parseFloat(valor.replace(/[,]/g, ""));
			}
			return 0;
		},
		enviaBasePessoal() {
			let assert =
				this.alimento.nome.length >= 3 && this.alimento.tipo !== null;
			if (!assert) {
				let msg =
					this.strings[this.idioma].campos_faltantes +
					(this.alimento.nome.length < 3
						? "\n O alimento deve ter no mínimo 3 caracteres!!!"
						: "");
				let time = 6000;
				this.$store.commit("openErrorAlert", { msg, time });
				let title = "❌ ATENÇÃO";
				this.$store.commit("openOKModal", {
					title,
					msg,
					error: true,
				});

				return;
			}
			this.alimento.user = this.user;
			this.alimento.id_pessoa = this.alimento.id_pessoa
				? this.alimento.id_pessoa
				: this.user.id;
			this.alimento.nome_ingles = this.alimento.nome_espanhol =
				this.alimento.nome;
			this.alimento.nome_cientifico = this.alimento.nome_sci;
			// this.alimento.id_empresa = this.empresa.id
			delete this.alimento.nome_sci;
			delete this.alimento.nutrientes_raw;
			this.alimento.id_tipo = this.alimento.tipo;
			let nutrientes = Object.assign({}, this.alimento.nutrientes);
			for (let ingredienteID in this.ingredientes) {
				let ingrediente = this.ingredientes[ingredienteID];
				if (!nutrientes[ingrediente.id]) nutrientes[ingrediente.id] = "0";
				nutrientes[ingrediente.id] = parseFloat(
					String(nutrientes[ingrediente.id]).replace(
						this.strings[this.idioma].separador_float,
						"."
					)
				);
			}
			this.alimento.nutrientes = JSON.stringify(nutrientes);
			delete this.alimento.tipo;
			delete this.alimento.user;
			delete this.alimento.empresa;
			this.axios
				.post("empresa/addAlimento", { alimento: this.alimento })
				.then((res) => {
					let msg = this.strings[this.idioma].cadastrado;
					let title = "";
					this.$store.commit("openOKModal", { title, msg });
					// window.location.go(0)
					// console.log(res)
				})
				.catch((err) => {
					console.log(err);
				});
		},
		async loadAlimentosDieta() {
			this.loadingAlimentos = true;
			this.loadingStep1 = true;

			getAlimentos(this.$store, this.axios)
				.then((r) => {
					this.loadingAlimentos = false;
					this.loadingStep1 = false;
					// this.loadData()
				})
				.catch((e) => {
					this.loadingAlimentos = false;
					this.loadingStep1 = false;
					// this.loadData()
				});
		},
		envia() {
			let assert =
				this.alimento.nome.length >= 3 && this.alimento.tipo !== null;
			if (!assert) {
				let msg =
					this.strings[this.idioma].campos_faltantes +
					(this.alimento.nome.length < 3
						? "\n O alimento deve ter no mínimo 3 caracteres!!!"
						: "");
				let time = 6000;
				this.$store.commit("openErrorAlert", { msg, time });
				let title = "❌ ATENÇÃO";
				this.$store.commit("openOKModal", {
					title,
					msg,
					error: true,
				});

				return;
			}
			this.alimento.user = this.user;
			localStorage.setItem("alimento", this.alimento);
			let alimento = this.alimento;
			let user = this.user;
			if (this.basePessoal) {
				return this.enviaBasePessoal();
			}
			this.axios
				.post("https://cqbal.com.br/api/brcorte/enviaAlimento", {
					alimento: alimento,
					user: user,
				})
				.then((response) => {
					console.log(response);
					let msg = this.strings[this.idioma].alimento_enviado;
					let time = 6000;
					this.$store.commit("openSuccessAlert", { msg, time });
					let title = "✔ Sucesso";
					this.$store.commit("openOKModal", {
						title,
						msg,
						error: false,
					});
				});
		},
	},
};
</script>
